import { render, staticRenderFns } from "./newreport.vue?vue&type=template&id=84b81d70&scoped=true&"
import script from "./newreport.vue?vue&type=script&lang=js&"
export * from "./newreport.vue?vue&type=script&lang=js&"
import style0 from "./newreport.vue?vue&type=style&index=0&id=84b81d70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b81d70",
  null
  
)

export default component.exports